import { TypeMachineProperties } from '../../interfaces/Dictionary.interfaces';

interface IMachineDataSectionStructure {
  sectionTitle: string;
  sectionData: TypeMachineProperties[];
  isRequiredSection?: boolean;
}

interface IMachineDataStructure {
  short: IMachineDataSectionStructure;
  long: IMachineDataSectionStructure[];
}

export const machineTableDataStructure: IMachineDataStructure = {
  short: {
    sectionTitle: '요약 정보',
    sectionData: ['series', 'model', 'horsePower', 'height', 'weight'],
  },
  long: [
    {
      sectionTitle: '기본정보',
      sectionData: ['model', 'length', 'width', 'height', 'weight'],
      isRequiredSection: true,
    },
    {
      sectionTitle: '핵심 정보',
      sectionData: [
        'engineOutputInPs',
        'displacement',
        'tankCapacity',
        'interaxialDistance',
        'groundClearance',
        'frontTire',
        'rearTire',
        'ptoType',
        'ptoShiftNumber',
        'ratedRpm1',
        'ratedRpm2',
        'ratedRpm3',
        'forwardHydraulicOutlet',
        'rearHydraulicOutlet',
        'hydraulicSystem',
      ],
      isRequiredSection: true,
    },
    {
      sectionTitle: '엔진부',
      sectionData: [
        'engineModel',
        'engineType',
        'engineOutputInPs',
        'engineOutputInKw',
        'engineOutputInRpm',
        'tankCapacity',
        'displacement',
        'fuelType',
      ],
    },
    {
      sectionTitle: '주행부',
      sectionData: [
        'drivingSeatType',
        'shiftMethod',
        'forwardShiftNumber',
        'rearShiftNumber',
        'maxSpeed',
        'drivingMethod',
        'clutchType',
        'steeringType',
        'maxForwardSpeed',
        'maxReverseSpeed',
      ],
    },
    {
      sectionTitle: 'PTO',
      sectionData: ['ptoType', 'ptoShiftNumber', 'ratedRpm1', 'ratedRpm2', 'ratedRpm3'],
    },
    {
      sectionTitle: '치수 및 무게',
      sectionData: ['length', 'width', 'height', 'groundClearance', 'weight'],
    },
    {
      sectionTitle: '타이어',
      sectionData: ['frontTire', 'rearTire'],
    },
  ],
};
